import React, { useContext, useState, Fragment } from "react";
import { Theme, makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Typography,
  Button,
  Popover,
  TextField,
} from "@material-ui/core";
import {
  PoleDefault,
  LabelPole,
  CableDefault,
} from "../../material/icons/equipemnt";
import { DesignContext } from "../../context/design";
import { ChromePicker } from "react-color";
import { _hexToRGBA } from "../../constant/commons";

const useStyle = makeStyles((theme: Theme) => ({
  gridRow: {
    display: "flex",
  },
  labelType: { paddingLeft: theme.spacing(2) },
  btnToggle: {
    minWidth: "unset",
    padding: 2,
    backgroundColor: theme.palette.common.white,
  },
  inputWidth: {
    "& input": {
      padding: theme.spacing(0.5),
      width: theme.spacing(4),
    },
    margin: 0,
  },
}));

const EquipDesignAppearance = () => {
  const classes = useStyle();
  const [colorpickEl, setcolorpickEl] = useState<HTMLButtonElement | null>(
    null
  );
  const { map, event, setevent } = useContext(DesignContext);
  const { feature } = event;

  const _changeColor = (e: any) => {
    const target =
      colorpickEl?.id === "equip-fill"
        ? "fill"
        : colorpickEl?.id === "equip-stroke"
        ? "stroke"
        : "textFill";
    let mapEvent: any = map;
    const draw = mapEvent._controls.find((control: any) => control.modes);
    if (target === "fill") {
      setevent({
        ...event,
        feature: {
          ...feature,
          properties: {
            ...feature?.properties,
            [target]: e.hex,
            fillOpacity: e.rgb.a,
          },
        },
      });
      draw.setFeatureProperty(feature?.id, "fill", e.hex);
      draw.setFeatureProperty(feature?.id, "fillOpacity", e.rgb.a);
    } else if (target === "stroke") {
      setevent({
        ...event,
        feature: {
          ...feature,
          properties: {
            ...feature?.properties,
            [target]: e.hex,
            strokeOpacity: e.rgb.a,
          },
        },
      });
      draw.setFeatureProperty(feature?.id, "stroke", e.hex);
      draw.setFeatureProperty(feature?.id, "strokeOpacity", e.rgb.a);
    } else if (target === "textFill") {
      setevent({
        ...event,
        feature: {
          ...feature,
          properties: {
            ...feature?.properties,
            [target]: e.hex,
          },
        },
      });
      draw.setFeatureProperty(feature?.id, target, e.hex);
    }
  };

  const changeStrokeWidth = (e: React.ChangeEvent<HTMLInputElement>) => {
    let mapEvent: any = map;
    const draw = mapEvent._controls.find((control: any) => control.modes);

    setevent({
      ...event,
      feature: {
        ...feature,
        properties: {
          ...feature?.properties,
          strokeWidth: Number(e.currentTarget.value),
        },
      },
    });
    draw.setFeatureProperty(
      feature?.id,
      "strokeWidth",
      Number(e.currentTarget.value)
    );
  };

  // const onChangeRotate = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   let mapEvent: any = map;
  //   const draw = mapEvent._controls.find((control: any) => control.modes);
  //   setevent({
  //     ...event,
  //     feature: {
  //       ...feature,
  //       properties: {
  //         ...feature?.properties,
  //         iconRotate: Number(e.target.value),
  //       },
  //     },
  //   });
  //   draw.setFeatureProperty(feature?.id, "iconRotate", Number(e.target.value));
  // };

  return (
    <Grid container spacing={2}>
      {map && (
        <Popover
          open={Boolean(colorpickEl)}
          anchorEl={colorpickEl}
          onClose={() => {
            setcolorpickEl(null);
          }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <ChromePicker
            onChange={_changeColor}
            color={
              colorpickEl?.id === "equip-fill"
                ? _hexToRGBA(
                    feature?.properties?.fill
                      ? feature?.properties?.fill
                      : "#000000",
                    feature?.properties?.fillOpacity
                      ? feature?.properties?.fillOpacity
                      : 1
                  )
                : colorpickEl?.id === "equip-stroke"
                ? _hexToRGBA(
                    feature?.properties?.stroke
                      ? feature?.properties?.stroke
                      : "#000000",
                    feature?.properties?.strokeOpacity
                      ? feature?.properties?.strokeOpacity
                      : 1
                  )
                : colorpickEl?.id === "equip-label"
                ? _hexToRGBA(
                    feature?.properties?.textFill
                      ? feature?.properties?.textFill
                      : "#000000",
                    1
                  )
                : "#000000"
            }
          />
        </Popover>
      )}
      {feature?.properties?.equip_type !== "equip-cable" && (
        <Fragment>
          <Grid item xs={6} className={classes.gridRow}>
            <Button
              variant="contained"
              id="equip-fill"
              className={classes.btnToggle}
              onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                setcolorpickEl(event.currentTarget);
              }}
            >
              <PoleDefault
                viewBox="9 9 32 32"
                style={{
                  height: 24,
                  width: 24,
                  fill: feature?.properties?.fill,
                  fillOpacity: feature?.properties?.fillOpacity,
                }}
              />
            </Button>
            <Typography variant="body1" className={classes.labelType}>
              Fill
            </Typography>
          </Grid>
          <Grid item xs={6} className={classes.gridRow}>
            <Button
              variant="contained"
              id="equip-stroke"
              className={classes.btnToggle}
              onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                setcolorpickEl(event.currentTarget);
              }}
            >
              <PoleDefault
                viewBox="9 9 32 32"
                style={{
                  height: 24,
                  width: 24,
                  fillOpacity: 0,
                  stroke: feature?.properties?.stroke,
                  strokeWidth: feature?.properties?.strokeWidth,
                }}
              />
            </Button>
            <Typography variant="body1" className={classes.labelType}>
              Stroke
            </Typography>
          </Grid>
        </Fragment>
      )}
      {feature?.properties?.equip_type === "equip-cable" && (
        <Fragment>
          <Grid item xs={6} className={classes.gridRow}>
            <div>
              <Button
                variant="contained"
                id="equip-stroke"
                className={classes.btnToggle}
                onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                  setcolorpickEl(event.currentTarget);
                }}
              >
                <CableDefault
                  viewBox="9 9 32 32"
                  style={{
                    height: 24,
                    width: 24,
                    fillOpacity: 0,
                    stroke: feature?.properties?.stroke,
                    strokeWidth: 7.5,
                  }}
                />
              </Button>
            </div>

            <Typography variant="body1" className={classes.labelType}>
              Stroke
            </Typography>
          </Grid>
          <Grid item xs={6} className={classes.gridRow}>
            <TextField
              variant="outlined"
              value={
                feature?.properties?.strokeWidth
                  ? feature?.properties?.strokeWidth
                  : 1
              }
              className={classes.inputWidth}
              type="number"
              margin="dense"
              onChange={changeStrokeWidth}
            />
            <Typography variant="body1" className={classes.labelType}>
              Width
            </Typography>
          </Grid>
        </Fragment>
      )}
      {(feature?.properties?.equip_type === "equip-pole" ||
        feature?.properties?.equip_type === "equip-meter" ||
        feature?.properties?.equip_type === "equip-switch" ||
        feature?.properties?.equip_type === "equip-relay") && (
        <Fragment>
          <Grid
            item
            xs={6}
            className={classes.gridRow}
            style={{ justifyContent: "center", flexDirection: "column" }}
          >
            <div className={classes.gridRow}>
              <Button
                variant="contained"
                id="equip-label"
                className={classes.btnToggle}
                onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                  setcolorpickEl(event.currentTarget);
                }}
              >
                <LabelPole
                  viewBox="0 0 50 25"
                  style={{
                    height: 24,
                    width: 24,
                    fontSize: "3rem",
                    fill: feature?.properties?.textFill
                      ? feature?.properties?.textFill
                      : "#000000",
                    fillOpacity: 1,
                    stroke: feature?.properties?.textFill
                      ? feature?.properties?.textFill
                      : "#000000",
                  }}
                >
                  T
                </LabelPole>
              </Button>
              <Typography variant="body1" className={classes.labelType}>
                Text Color
              </Typography>
            </div>
          </Grid>
        </Fragment>
      )}
    </Grid>
  );
};

export default EquipDesignAppearance;
